angular.module('dictionary')
    .controller('DictionaryDialogController', function ($scope, $rootScope, $uibModalInstance, data, toastr, Dictionary) {
        this.item = data;
        this.cancel = () => $uibModalInstance.dismiss('Canceled');

        this.save = () => {
            let promise
            if (this.item.id !== null) {
                promise = Dictionary.update(this.item).$promise;
            } else {
                promise = Dictionary.save(this.item).$promise;
            }
            return promise.then(result => {
                $rootScope.$broadcast(`dictionary-${this.item.type}.updated`);
                $uibModalInstance.close(result);
                toastr.success("Zapisano");
            })
        };
    })
